export async function fetchTopTraders(from, to, limit = 100): Promise<any> {
	return (
		await fetch(
			`https://data.fluxbeam.xyz/stats/traders/top?from=${from}&to=${to}&limit=${limit}`
		)
	).json();
}

export async function fetchTopTokens({ limit }): Promise<any> {
	return (
		await fetch(
			`https://data.fluxbeam.xyz/stats/tokens/top?limit=${limit}&interval=60`
		)
	).json();
}

export async function fetchTopPositions({ page, limit }): Promise<any> {
	return (
		await fetch(
			`https://data.fluxbeam.xyz/stats/positions/top?page=${page}&limit=${limit}`
		)
	).json();
}

export async function fetchTraderTrades({
	wallet,
	limit = 100,
}: any): Promise<any> {
	return (
		await fetch(
			`https://data.fluxbeam.xyz/traders/${wallet}/trades?limit=${limit}`
		)
	).json();
}

export async function fetchTokenTrades({
	mint,
	from,
	to,
	limit = 100,
	signal,
}: any): Promise<any> {
	return (
		await fetch(
			`https://data.fluxbeam.xyz/tokens/${mint}/trades?from=${from}&to=${to}&limit=${limit}`,
			{ signal }
		)
	).json();
}
